<template>
  <div>
    <div class="d-flex align-center mb-2">
      <v-icon left small>mdi-paperclip</v-icon>
      <span class="subtitle-2">Attachments</span>
      <v-spacer></v-spacer>
      <v-btn icon x-small :loading="loading" @click="refresh()"><v-icon x-small>mdi-refresh</v-icon></v-btn>
    </div>

    <div v-if="!loading && attachments.length === 0" class="grey--text text-caption py-2">
      No attachments yet.
    </div>

    <v-row dense>
      <v-col v-for="a in attachments" :key="a.id" cols="4" sm="3" md="2">
        <v-card outlined>
          <v-img :src="a.url" aspect-ratio="1" @click="openImage(a.url)" style="cursor:pointer"></v-img>
          <div class="pa-1 text-center">
            <div class="text-caption text-truncate">{{ uploaderName(a) }}</div>
            <div class="text-caption grey--text">{{ formatDate(a.createdAt) }}</div>
            <v-btn icon x-small color="error" @click="remove(a)"><v-icon x-small>mdi-delete</v-icon></v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'AttachmentsPanel',
  props: {
    targetType: { type: String, required: true },
    targetId: { type: [Number, String], default: null },
  },
  data: () => ({ attachments: [], loading: false }),
  computed: { ...mapGetters(['getEndpoint']) },
  watch: {
    targetId(v) { if (v) this.refresh() },
  },
  mounted() { if (this.targetId) this.refresh() },
  methods: {
    async refresh() {
      if (!this.targetId) return
      this.loading = true
      try {
        let { data } = await axios.get(`${this.getEndpoint}/api/attachment/${this.targetType}/${this.targetId}`)
        this.attachments = (data && data.data) || []
      } catch (e) { /* leave existing list */ }
      this.loading = false
    },
    async remove(a) {
      if (!confirm('Remove this attachment?')) return
      try {
        await axios.delete(`${this.getEndpoint}/api/attachment/${a.id}`)
        this.attachments = this.attachments.filter(x => x.id !== a.id)
      } catch (e) { /* noop */ }
    },
    openImage(url) { window.open(url, '_blank') },
    uploaderName(a) {
      let u = a.aUploadedBy
      return u ? `${u.firstName || ''} ${u.lastName || ''}`.trim() : ''
    },
    formatDate(d) { return d ? new Date(d).toLocaleDateString() : '' },
  },
}
</script>
